<template>
  <b-modal :id="id" size="md" centered :title="titel" footer-class="modal-footer--centered">
    <p class="status-bestaetigen__text">Möchtest du den Status wirklich auf "{{ statusText }}" setzen?</p>
    <template #modal-footer="{ hide }">
      <b-button class="dialog-btn-secondary" @click="hide">Abbrechen</b-button>
      <b-button class="dialog-btn" variant="primary" @click="onConfirm(hide)">Speichern</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalStatusBestaetigen',
  props: {
    id: { type: String, required: true },
    statusText: { type: String, default: '' },
  },
  computed: {
    titel() {
      return `Status auf "${this.statusText}"`;
    },
  },
  methods: {
    onConfirm(hide) {
      this.$emit('confirm');
      hide();
    },
  },
};
</script>

<style scoped>
.status-bestaetigen__text {
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: var(--text-body);
}
</style>
